/*
 * RightActions Messages
 *
 * This contains all the text for the RightActions component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.RightActions';

export default defineMessages({
  addQuestion: {
    id: `${scope}.addQuestion`,
    defaultMessage: 'Add question',
  },
  addSection: {
    id: `${scope}.addSection`,
    defaultMessage: 'Add section',
  },
});
